import { convertBJ2Hands } from '@/models/games/blackjack2/GameInfo';
import { GameType as GameTypeEnum } from '@/models/games/enums/GameType';
import { tableBetSliceActions } from '@/modules/betTable/slice';
import { SupportedGameResult } from '@/modules/host/models';
import { getHostById, hostsSliceActions } from '@/modules/host/slice';
import {
    getHostLiveDataByHostId,
    hostLiveSliceActions,
} from '@/modules/hostLive/slice';
import { bj2HandSliceActions } from '@/modules/rwdGame/blackjack2/slice/handSlice';
import { bj2SeatSliceActions } from '@/modules/rwdGame/blackjack2/slice/seatSlice';
import store from '@/store/store';
import { Dispatch } from 'react';
import { batch } from 'react-redux';
import { Action } from 'redux';
import { CMDScNewBlackjackReady, ICommand } from '../live';
import { AbstractHandler } from './AbstractHandler';

export class CMDScNewBlackjackReadyHandler extends AbstractHandler {
    _command: CMDScNewBlackjackReady;
    constructor(command: ICommand) {
        super();
        this._command = command as CMDScNewBlackjackReady;
    }
    override handle(dispatch: Dispatch<Action>): void {
        const newResult = {} as SupportedGameResult;
        newResult.GameID = this._command.GameID;
        newResult.GameCount = this._command.GameCount;
        const state = store.getState();
        // const { PlayerID } = getMainUserState(state);
        const host = getHostById(state, this._command.HostID);
        const hostLiveData = getHostLiveDataByHostId(
            state,
            this._command.HostID
        );
        hostLiveData.ShuffleTimer && clearTimeout(hostLiveData.ShuffleTimer);
        batch(() => {
            const data = convertBJ2Hands(
                this._command.JSON,
                this._command.HostID
            );
            dispatch(
                bj2HandSliceActions.updateHands({
                    hostId: this._command.HostID,
                    ...data,
                })
            );
            dispatch(
                bj2SeatSliceActions.updateDecisionStateStep({
                    hostId: host.HostId,
                    step: '',
                })
            );
            dispatch(
                hostLiveSliceActions.startBet({
                    hostId: this._command.HostID,
                    result: newResult,
                    remainTime: 0,
                    countDown: 0,
                    pendingTime: 0,
                    canLeave: true,
                })
            );
            dispatch(
                hostsSliceActions.startBet({
                    hostId: this._command.HostID,
                    result: newResult,
                    remainTime: 0,
                    countDown: 0,
                    pendingTime: 0,
                    canLeave: true,
                })
            );
            if (host.GameType == GameTypeEnum.Blackjack2) {
                dispatch(
                    tableBetSliceActions.startBJBet({
                        hostId: this._command.HostID,
                        gameId: this._command.GameID,
                    })
                );
            } else {
                dispatch(
                    tableBetSliceActions.startBet({
                        hostId: this._command.HostID,
                        gameId: this._command.GameID,
                    })
                );
            }
        });
    }
}
